import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=d56c4396&scoped=true&"
import script from "./SmallLoader.vue?vue&type=script&lang=js&"
export * from "./SmallLoader.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoader.vue?vue&type=style&index=0&id=d56c4396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c4396",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
